import React from 'react';
import { Link } from 'react-router-dom';
import style from './css/interest.module.css';

import ui from '../../assets/uiux.webp';
import data from '../../assets/datamanagement.png';
import ai from '../../assets/aiml.jpg';
import web from '../../assets/web-design.webp';

const Interest = () => {
  const courses = [
    { id: 1, title: "UI/UX Design", image: ui },
    { id: 2, title: "Artificial Intelligence", image: ai },
    { id: 3, title: "Web Development", image: web },
    { id: 4, title: "Database Management", image: data },
  ];

  return (
    <section className={style.interestContainer}>
      <div className={style.interestRow}>
        <h2 className={style.interestTitle}>Are you interested in learning in-demand IT skills?</h2>
        <div className={style.interestColumn}>
          <p className={style.interestMainText}>
            Our well-crafted, industry-standard courses will give you a competitive edge in the tech industry.
            You’ll build real-world projects curated by our professional instructors.
          </p>
          <Link exact="true" to="/courses/career" className={style.link}>
            More courses
          </Link>
        </div>
      </div>

      <div className={style.cards}>
        {courses.map((course, index) => (
          <div key={course.id} className={`${style.card} ${style.fadeIn}`} style={{ animationDelay: `${0.2 * (index + 1)}s` }}>
            <img src={course.image} alt={course.title} className={style.cardImage} />
            <h3 className={style.cardTitle}>{course.title}</h3>
            <Link to="/courses/short-term" className={style.learnMoreBtn}>
              Learn More
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Interest;
